import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=b0bf4de4&scoped=true&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&id=b0bf4de4&prod&lang=scss&scoped=true&"
import style1 from "./Table.vue?vue&type=style&index=1&id=b0bf4de4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bf4de4",
  null
  
)

export default component.exports